import {
  FETCH_ACTIVITY_BOARD,
  FETCH_ACTIVITY_BOARD_SUCCESS,
  FETCH_ACTIVITY_BOARD_FAILURE,
} from "./constants";

const initialState = {
  isFetching: false,
  stats: null,
  programme: null,
  quietList: null,
  excused: [],
  away: null,
  nearbyPlaces: [],
  weather: [],
  whatWorks: [],
  range: null,
  location: null,
  generatedAt: null,
  error: null,
};

const ActivityBoardReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_ACTIVITY_BOARD:
      return { ...state, isFetching: true, error: null };
    case FETCH_ACTIVITY_BOARD_SUCCESS:
      return {
        ...state,
        isFetching: false,
        stats: action.payload?.stats ?? null,
        programme: action.payload?.programme ?? [],
        quietList: action.payload?.quietList ?? [],
        excused: action.payload?.excused ?? [],
        away: action.payload?.away ?? [],
        nearbyPlaces: action.payload?.nearbyPlaces ?? [],
        weather: action.payload?.weather ?? [],
        whatWorks: action.payload?.whatWorks ?? [],
        range: action.payload?.range ?? null,
        location: action.payload?.location ?? null,
        generatedAt: action.payload?.generatedAt ?? null,
      };
    case FETCH_ACTIVITY_BOARD_FAILURE:
      return { ...state, isFetching: false, error: true };
    default:
      return state;
  }
};

export default ActivityBoardReducer;
